import React, { useContext } from 'react';
import { array, func, string } from 'prop-types';
import { AppContext } from '../AppContext';
import googleMaps from '../../api/googleMaps'; 
function Hotels({ country, filtered, setHasHotels, setNumberOfHotels, destinationMap }) {
  const { onClick } = useContext(AppContext);

  function destionnationMap(e) {
    let markerId = e.target.parentElement.getAttribute('data-marker-id');
    let targetMarker; 
    if(googleMaps.markers && googleMaps.markers.length > 0) {
      targetMarker = googleMaps.markers.filter((marker) => {
        if(marker.id == markerId) {
          return true;
        }
      })
    }
    if(targetMarker.length > 0) {
      let map = googleMaps.returnMapInstance();
      map.panTo(targetMarker[0].getPosition());
      //map.panBy(-20, -80);
      google.maps.event.trigger(targetMarker[0], 'click');
    }
  }

  const hotels = filtered
    .filter(item => item.data)
    .map((item, index) => {
      return (
        <button
          key={index}
          onClick={(destinationMap) ? onClick : destionnationMap}
          className="cell small-12 medium-6 large-4 find-a-hotel-suggestion suggestion"
          style={{ textAlign: 'left' }}
          data-marker-id={item.index}
          aria-label={`${item.value}`}
        >
          <span>{item.value}</span>
          <div className="autocomplete-group">{item.data.location.replace(/,\s?,/g, ',')}</div>
        </button>
      );
    });

  if (setHasHotels && hotels.every(hotel => hotel === null)) {
    setHasHotels(false);
  }

  if (setNumberOfHotels) {
    setNumberOfHotels(hotels.length);
  }

  // if country prop is present, return this block
  if (country && hotels.length > 0) {
    return (
      <div className="hotels-group">
        <p className="country-name">{country} properties</p>
        {hotels}
      </div>
    );
  }

  // default return hotels
  return hotels;
}

Hotels.propTypes = {
  country: string,
  filtered: array.isRequired,
  setHasHotels: func
};

Hotels.defaultProps = {
  destinationMap: true,
}

export default Hotels;
